export default "__VITE_ASSET__APBlHbhq__"